module.exports = __webpack_public_path__ + "img/crystal_8_a.48c72a0c.jpg";